const sortByAlphabet = (a, b) => {
    const title1 = a;
    const title2 = b;

    let comparison = 0;
    if (title1 > title2) {
        comparison = 1;
    } else if (title1 < title2) {
        comparison = -1;
    }
    return comparison;
};
const sortByDate = (a, b) => {
    {
        return new Date(b).getTime() - new Date(a).getTime();
    }
};

export { sortByAlphabet, sortByDate };
